import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UtimacoKeyRef } from "src/app/api/models/utimaco-key-ref";
import { GetKeyInfoEndpointService } from "src/app/api/services";
import { LazyLoadingService } from "./lazy-loading.service";

@Injectable({
  providedIn: "root",
})
export class UtimacoHsmService extends LazyLoadingService<UtimacoKeyRef[]> {
  constructor(private service: GetKeyInfoEndpointService) {
    super({ data: [] });
  }
  protected override fetchData(): Observable<UtimacoKeyRef[]> {
    return this.service.apiV1KeyGet();
  }
}
